import { useCallback, useEffect, useRef, useState } from "react";
import { useParams } from "react-router-dom";

import SingleVacancy from "../../../pages/recruiting/vacancySingle/singleVacancy";

import SectionContent from "../../../components/sectionContent/sectionContent";
import HeaderBtn from "../../../components/headerBtn/headerBtn";
import Sidebar from "../../../components/sidebar/Sidebar";

import "../../../scss/App.scss";
import { useSelector } from "react-redux";
import { IUserOptions } from "../../../types/interfaces";

const IS_VISIBLE_SIDEBAR = process.env.REACT_APP_IS_VISIBLE_SIDEBAR;

const VacancySingleSection = () => {
  const { id } = useParams<{ id: string }>();
  const { inputValues } = useSelector(
    (state: any) => state.recruiting.singleVacancy
  );
  const { isOpenSidebar } = useSelector(
    (state: IUserOptions) => state.user.user
  );
  const { claims } = useSelector((state: any) => state.user.user.data);
  const [overflowedBtnsCount, setOverflowedBtnsCount] = useState<number>(0);
  const [isOpenGroupBtn, setIsOpenGroupBtn] = useState<boolean>(false);

  const buttonsContainerRef = useRef<HTMLDivElement>(null);
  const headFilterRef = useRef<any>(null);

  const sidebarWidth = isOpenSidebar ? 190 : 44;
  const headerFiltersAndSelectWidth = 525;
  const minEmptyWidthForNewBtn = 300;
  const groupBtnWidth = 70;
  const buttonWidth = 130;

  let showBtn = false;
  if (
    inputValues &&
    inputValues.status !== "BY_MISTAKE" &&
    inputValues.status !== "FILLED"
  ) {
    showBtn =
      inputValues.type === "ON_ROUTE" || inputValues.type === "PARTIAL_ROUTE";
  }

  const availableButtons = [
    showBtn &&
      (claims.includes("admin") || claims.includes("projects:routes:list")) && {
        component: (
          <HeaderBtn
            content="Настройки"
            purpose="vacantRoutesSettings"
            modalTitle="Настройки"
          />
        ),
      },
    (claims.includes("admin") ||
      claims.includes("recruiting:vacancy:edit")) && {
      component: (
        <HeaderBtn
          content="Сохранить"
          purpose="vacancyUpdate"
          modalTitle="Сохранение вакансии"
        />
      ),
    },
    (claims.includes("admin") ||
      (claims.includes("recruiting:vacancy:edit") &&
        claims.includes("projects:routes:list"))) &&
      showBtn && {
        component: (
          <HeaderBtn
            content="Удалить маршрут"
            purpose="deleteRoute"
            modalTitle="Удаление маршрута"
          />
        ),
      },
    (claims.includes("admin") ||
      (claims.includes("recruiting:vacancy:edit") &&
        claims.includes("projects:routes:list"))) &&
      showBtn && {
        component: (
          <HeaderBtn
            content="Добавить маршрут"
            purpose="addRouteOnVacancy"
            modalTitle="Добавление маршрута"
          />
        ),
      },
    {
      component: (
        <HeaderBtn
          content="Вернуться к списку"
          purpose="navigateToVacancyList"
          modalTitle="Переход к списку вакансий"
        />
      ),
    },
    (claims.includes("admin") ||
      claims.includes("recruiting:vacancy:edit")) && {
      component: (
        <HeaderBtn
          content="Снять выделения"
          purpose="removeSelections"
          modalTitle="Снятие выделения"
        />
      ),
    },
  ];

  const filteredAvailableButtons = availableButtons.filter(
    (btn: { component: JSX.Element }) => btn
  );

  useEffect(() => {
    if (
      filteredAvailableButtons.slice(-(overflowedBtnsCount as number)).length +
        filteredAvailableButtons.slice(
          0,
          filteredAvailableButtons.length - overflowedBtnsCount
        ).length >
      filteredAvailableButtons.length
    ) {
      setOverflowedBtnsCount(0);
    }
  }, [filteredAvailableButtons, overflowedBtnsCount]);

  const handleWindowResize = useCallback(() => {
    const allButtonsWidth =
      filteredAvailableButtons.slice(
        0,
        filteredAvailableButtons.length - overflowedBtnsCount
      ).length * buttonWidth;
    const spaceToLeftSideOfFilters =
      headFilterRef.current?.getBoundingClientRect().left;
    const windowWidth = window.innerWidth;
    const isOverflowed = JSON.parse(IS_VISIBLE_SIDEBAR as string)
      ? allButtonsWidth >
        windowWidth - headerFiltersAndSelectWidth - sidebarWidth
      : allButtonsWidth > windowWidth - headerFiltersAndSelectWidth;

    if (isOverflowed) {
      setIsOpenGroupBtn(true);
      setOverflowedBtnsCount((prevValue: number) => {
        if (overflowedBtnsCount === filteredAvailableButtons.length) {
          return prevValue;
        } else {
          return overflowedBtnsCount + 1;
        }
      });
    }
    const isEnoughtSpace = JSON.parse(IS_VISIBLE_SIDEBAR as string)
      ? spaceToLeftSideOfFilters -
          sidebarWidth -
          allButtonsWidth +
          groupBtnWidth >
        minEmptyWidthForNewBtn
      : spaceToLeftSideOfFilters - allButtonsWidth + groupBtnWidth >
        minEmptyWidthForNewBtn;
    if (isEnoughtSpace) {
      setOverflowedBtnsCount((prevValue: number) => {
        if (prevValue <= 1) {
          setIsOpenGroupBtn(false);
          return 0;
        } else return prevValue - 1;
      });
    }
  }, [
    filteredAvailableButtons,
    overflowedBtnsCount,
    sidebarWidth,
    headerFiltersAndSelectWidth,
  ]);

  useEffect(() => {
    handleWindowResize();
    window.addEventListener("resize", handleWindowResize);

    return () => {
      window.removeEventListener("resize", handleWindowResize);
    };
  }, [handleWindowResize]);

  const displayedAvailableBtns = filteredAvailableButtons
    ?.slice(-(overflowedBtnsCount as number))
    ?.map((elem: { component: JSX.Element }, index: number) => {
      return elem && <div key={index}>{elem?.component}</div>;
    });

  const displayedHeadBtns = filteredAvailableButtons
    ?.slice(0, filteredAvailableButtons.length - overflowedBtnsCount)
    ?.map((elem: { component: JSX.Element }, index: number) => {
      return elem && <div key={index}>{elem?.component}</div>;
    });

  return (
    <div className="App">
      <Sidebar />
      <SectionContent
        availableButtons={displayedAvailableBtns}
        buttonsContainerRef={buttonsContainerRef}
        headBlockChildren={displayedHeadBtns}
        isOpenGroupBtn={isOpenGroupBtn}
        pageName="recruitingSingle"
        section="Набор персонала"
        title="Вакансии"
        tail={"Вакансия №" + id}
      >
        <div className="content__single_report">
          <div className="btns" style={{ margin: "0 0 7px 4px" }}></div>
          <SingleVacancy />
        </div>
      </SectionContent>
    </div>
  );
};

export default VacancySingleSection;
